import api from './apicall.js'
import processors from './processors.js'


const actions = {
	
	/*
		THESE ARE USED FOR REST API -- NOT WEBSOCKETS, WHICH IS WHERE THIS DATA COMES FROM IN NON-ERROR CASE.
		
	 For that reason updateQ and updateAgents are designed only to be used as failure for websockets/ in memory store.
	  By deployment time, calling them should implicitly call a function that assigns the new data elements to the redis store,
	  and forces a cold start of new socket channel.
	
	 */
	
	//need to add commit for the geography section.
	login(context, data) {
		return api.post('/accounts/login/', data)
				.then((response) => {
					console.log(response)
					context.commit('USER_DATA', processors.login(response))
					context.commit('GEOGRAPHY_DATA', response.data.organization)
				})
				.catch(function(error) { context.commit('USER_ERROR', error); console.log(error)});
		// final .then to end the pending flag
	},
	
	logout(context) {
		context.commit('USER_DATA', {})
		localStorage.access = "";
		localStorage.refresh = "";
	},

	globalAlertCreate(context, data) {
		console.log("DISPATCH GLOBAL ALERT", data)
		context.commit('GLOBAL_ALERT_CREATE', data)
	},

    globalAlertReset(context) {
		console.log("REMOVE GLOBAL ALERT");
		context.commit('GLOBAL_ALERT_RESET')
	},

	introStatus(context, status) {
		context.commit('INTRO_STATUS', status)
	},

	
	updateGeography(context, data) {
		context.commit('GEOGRAPHY_DATA', data );
	},
	
	toggleHeader(context) {
		context.commit('TOGGLE_HEADER')
	},
	
	hideHeader(context) {
		context.commit('HIDE_HEADER')
	},
	
	showHeader(context) {
		context.commit('SHOW_HEADER')
	},

	toggleLoad(context) {
		context.commit('TOGGLE_LOAD')
	}


	
};

export default actions;
